<div class="comparison-grid expanded-mode"
     data-test="member-comparison-grid"
     [formGroup]="form()"
>

  <!-- External Insured Name -->
  <div formGroupName="name">
    <albert-input class="origami-field"
                  controlName="externalValue"
                  data-test="external-name"
                  groupName="name"
                  inputId="ext_name"
                  label="Insured Name"
                  [disabled]="true"
    />
  </div>
  <!-- Local Insured Name -->
  <div class="override-cell"
       formGroupName="name"
  >
    <albert-override-wrapper data-test="override-wrapper-name"
                             tooltipLabel="Insured Name"
                             [disabled]="!canEdit()"
                             [isVisible]="isFieldVisible('name')"
                             (visibilityChange)="toggleField('name')"
    >
      <albert-input controlName="localValue"
                    data-test="override-name"
                    groupName="name"
                    inputId="loc_name"
                    label="Insured Name"
                    [disabled]="!canEdit()"
                    [required]="isLocalValueRequired('name')"
      />
      @let nameControl = form().controls.name.controls.localValue;
      @if (nameControl.errors?.['memberExists'] && nameControl.touched) {
        <small class="block text-red-500 text-xs mt-1"
               data-test="member-exists-error"
        >
          This insured already exists. Please choose a different name.
        </small>
      }
    </albert-override-wrapper>
  </div>

  <!-- External companyCode -->
  <div formGroupName="companyCode">
    <albert-input class="origami-field"
                  controlName="externalValue"
                  data-test="external-companyCode"
                  groupName="companyCode"
                  inputId="ext_companyCode"
                  label="Company Code"
                  [disabled]="true"
    />
  </div>
  <!-- Local companyCode -->
  <div class="override-cell"
       formGroupName="companyCode"
  >
    <albert-override-wrapper data-test="override-wrapper-companyCode"
                             tooltipLabel="Company Code"
                             [disabled]="!canEdit()"
                             [isVisible]="isFieldVisible('companyCode')"
                             (visibilityChange)="toggleField('companyCode')"
    >
      <albert-input controlName="localValue"
                    data-test="override-companyCode"
                    groupName="companyCode"
                    inputId="loc_companyCode"
                    label="Company Code"
                    [disabled]="!canEdit()"
                    [required]="isLocalValueRequired('companyCode')"
      />
    </albert-override-wrapper>
  </div>

  <!-- Co-Insurance is override-only -->
  <div class="origami-field">
  </div>
  <!-- local parentCompany checkbox -->
  <div class="override-cell"
       formGroupName="parentCompany"
  >
    <div class="field-group h-full">
      <albert-checkbox controlName="checked"
                       data-test="override-coInsurance"
                       groupName="parentCompany"
                       inputId="loc_coInsurance"
                       label="Co-Insurance"
                       [disabled]="!canEdit()"
      />
    </div>
  </div>

  <!-- Parent Company is override-only -->
  <div class="origami-field">
  </div>
  <!-- Local parentCompany -->
  <div class="override-cell"
       formGroupName="parentCompany"
  >
    @if (isParentCompanyChecked()) {
      <p-iftalabel class="w-full">
        <p-autocomplete class="w-full"
                        formControlName="localValue"
                        id="ovr_parent"
                        [attr.data-test]="'parentCompanyOfInsuredOverride'"
                        [dropdown]="true"
                        [forceSelection]="true"
                        [minQueryLength]="3"
                        [suggestions]="parentCompanies()"
                        (completeMethod)="onParentCompaniesSearch($event)"
        />
        <label for="ovr_parent">Parent Company of Insured</label>
      </p-iftalabel>
      @let parentCompanyControl = form().controls.parentCompany.controls.localValue;
      @if (canEdit() && parentCompanyControl.hasError('required')) {
        <small class="block text-red-500 text-xs mt-1"
               data-test="parentCompany-required-error"
        >Parent Company of Insured is required.</small>
      }
    }
  </div>

  <!-- Address fields, collapsed by default -->
  <div class="col-span-full">
    <p-accordion data-test="member-address-accordion"
                 [multiple]="true"
    >
      <p-accordion-panel data-test="member-address-panel"
                         value="address"
      >
        <p-accordion-header data-test="member-address-header">
          <p class="section-title"> Address of Insured</p>
        </p-accordion-header>
        <p-accordion-content data-test="member-address-content">
          <div class="comparison-grid expanded-mode"
               data-test="member-address-comparison-grid"
          >
            <!-- External Street1 -->
            <div formGroupName="street1">
              <albert-input class="origami-field"
                            controlName="externalValue"
                            data-test="external-street1"
                            groupName="street1"
                            inputId="ext_street1"
                            label="Street 1"
                            [disabled]="true"
              />
            </div>
            <!-- Local Street1 -->
            <div class="override-cell"
                 formGroupName="street1"
            >
              <albert-override-wrapper data-test="override-wrapper-street1"
                                       tooltipLabel="Street 1"
                                       [disabled]="!canEdit()"
                                       [isVisible]="isFieldVisible('street1')"
                                       (visibilityChange)="toggleField('street1')"
              >
                <albert-input controlName="localValue"
                              data-test="override-street1"
                              groupName="street1"
                              inputId="loc_street1"
                              label="Street 1"
                              [disabled]="!canEdit()"
                />
              </albert-override-wrapper>
            </div>

            <!-- External Street2 -->
            <div formGroupName="street2">
              <albert-input class="origami-field"
                            controlName="externalValue"
                            data-test="external-street2"
                            groupName="street2"
                            inputId="ext_street2"
                            label="Street 2"
                            [disabled]="true"
              />
            </div>
            <!-- Local Street2 -->
            <div class="override-cell"
                 formGroupName="street2"
            >
              <albert-override-wrapper data-test="override-wrapper-street2"
                                       tooltipLabel="Street 2"
                                       [disabled]="!canEdit()"
                                       [isVisible]="isFieldVisible('street2')"
                                       (visibilityChange)="toggleField('street2')"
              >
                <albert-input controlName="localValue"
                              data-test="override-street2"
                              groupName="street2"
                              inputId="loc_street2"
                              label="Street 2"
                              [disabled]="!canEdit()"
                />
              </albert-override-wrapper>
            </div>

            <!-- External Street3 -->
            <div formGroupName="street3">
              <albert-input class="origami-field"
                            controlName="externalValue"
                            data-test="external-street3"
                            groupName="street3"
                            inputId="ext_street3"
                            label="Street 3"
                            [disabled]="true"
              />
            </div>
            <!-- Local Street3 -->
            <div class="override-cell"
                 formGroupName="street3"
            >
              <albert-override-wrapper data-test="override-wrapper-street3"
                                       tooltipLabel="Street 3"
                                       [disabled]="!canEdit()"
                                       [isVisible]="isFieldVisible('street3')"
                                       (visibilityChange)="toggleField('street3')"
              >
                <albert-input controlName="localValue"
                              data-test="override-street3"
                              groupName="street3"
                              inputId="loc_street3"
                              label="Street 3"
                              [disabled]="!canEdit()"
                />
              </albert-override-wrapper>
            </div>

            <!-- External Postal Code -->
            <div formGroupName="postalCode">
              <albert-input class="origami-field"
                            controlName="externalValue"
                            data-test="external-postalCode"
                            groupName="postalCode"
                            inputId="ext_postalCode"
                            label="Postal Code"
                            [disabled]="true"
              />
            </div>
            <!-- Local Postal Code -->
            <div class="override-cell"
                 formGroupName="postalCode"
            >
              <albert-override-wrapper data-test="override-wrapper-postalCode"
                                       tooltipLabel="Postal Code"
                                       [disabled]="!canEdit()"
                                       [isVisible]="isFieldVisible('postalCode')"
                                       (visibilityChange)="toggleField('postalCode')"
              >
                <albert-input controlName="localValue"
                              data-test="override-postalCode"
                              groupName="postalCode"
                              inputId="loc_postalCode"
                              label="Postal Code"
                              [disabled]="!canEdit()"
                />
              </albert-override-wrapper>
            </div>

            <!-- External city -->
            <div formGroupName="city">
              <albert-input class="origami-field"
                            controlName="externalValue"
                            data-test="external-city"
                            groupName="city"
                            inputId="ext_city"
                            label="City"
                            [disabled]="true"
              />
            </div>
            <!-- Local city -->
            <div class="override-cell"
                 formGroupName="city"
            >
              <albert-override-wrapper data-test="override-wrapper-city"
                                       tooltipLabel="City"
                                       [disabled]="!canEdit()"
                                       [isVisible]="isFieldVisible('city')"
                                       (visibilityChange)="toggleField('city')"
              >
                <albert-input controlName="localValue"
                              data-test="override-city"
                              groupName="city"
                              inputId="loc_city"
                              label="City"
                              [disabled]="!canEdit()"
                />
              </albert-override-wrapper>
            </div>

            <!-- External state -->
            <div formGroupName="state">
              <albert-input class="origami-field"
                            controlName="externalValue"
                            data-test="external-state"
                            groupName="state"
                            inputId="ext_state"
                            label="State"
                            [disabled]="true"
              />
            </div>
            <!-- Local state -->
            <div class="override-cell"
                 formGroupName="state"
            >
              <albert-override-wrapper data-test="override-wrapper-state"
                                       tooltipLabel="State"
                                       [disabled]="!canEdit()"
                                       [isVisible]="isFieldVisible('state')"
                                       (visibilityChange)="toggleField('state')"
              >
                <albert-input controlName="localValue"
                              data-test="override-state"
                              groupName="state"
                              inputId="loc_state"
                              label="State"
                              [disabled]="!canEdit()"
                />
              </albert-override-wrapper>
            </div>

            <!-- External country -->
            <div formGroupName="country">
              <albert-input class="origami-field"
                            controlName="externalValue"
                            data-test="external-country"
                            groupName="country"
                            inputId="ext_country"
                            label="Country"
                            [disabled]="true"
              />
            </div>
            <!-- Local country -->
            <div class="override-cell"
                 formGroupName="country"
            >
              <albert-override-wrapper data-test="override-wrapper-country"
                                       tooltipLabel="Country"
                                       [disabled]="!canEdit()"
                                       [isVisible]="isFieldVisible('country')"
                                       (visibilityChange)="toggleField('country')"
              >
                <albert-input controlName="localValue"
                              data-test="override-country"
                              groupName="country"
                              inputId="loc_country"
                              label="Country"
                              [disabled]="!canEdit()"
                />
              </albert-override-wrapper>
            </div>

            <!-- External Addition Address Information -->
            <div>
            </div>
            <!-- local Addition Address Information -->
            <div class="override-cell"
                 formGroupName="additionalAddressInformation"
            >
              <div class="field-group h-full">
                <albert-checkbox controlName="checked"
                                 data-test="override-additionalAddressInformation"
                                 groupName="additionalAddressInformation"
                                 inputId="loc_addInfo"
                                 label="Additional Address Information"
                                 [disabled]="!canEdit()"
                />
              </div>
            </div>

            @if (isAddInfoChecked()) {
              <div>
              </div>
              <div class="override-cell"
                   data-test="override-additionalAddressInformation-cell"
                   formGroupName="additionalAddressInformation"
              >
                <albert-input controlName="localValue"
                              data-test="override-additionalAddressInformation-text"
                              groupName="additionalAddressInformation"
                              inputId="loc_addInfoText"
                              label="Additional Address Information"
                              [disabled]="!canEdit()"
                />
              </div>
            }
          </div>
        </p-accordion-content>
      </p-accordion-panel>
    </p-accordion>
  </div>

  <!-- Contact of Insured is knowingly missing, implementation later when Contacts are available in the BE -->

</div>
